import { createAction } from 'redux-actions';

export const biFetchMoreFolderItems = createAction(
  'BI.FETCH_MORE_FOLDER_ITEMS',
  (streamId: string) => ({ streamId })
);

export const biClickProfileNavBar = createAction(
  'BI.PROFILE_NAV_BAR',
  (linkName: string) => ({ linkName })
);
